import React, { useState, createRef, useContext } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import DeleteIcon from '@mui/icons-material/DeleteOutlined'
import EditIcon from '@mui/icons-material/Edit'

import { getRoute, routePaths, userRightTypes } from '../../../../constants'
import { Logger, LoggerTypes } from '../../../../utils'
import { searchProjects } from '../../../../actions'
import { LoaderContext } from '../../../../contexts'
import { checkPermissions } from '../../../../components/AccessControl'

import { PageTitle, DataGrid, DataGridRowLink, ButtonIcon, AccessControl } from '../../../../components'
import { ProjectButtonFavorite } from '../../ProjectButtonFavorite'
import { ProjectDialogUpdate, ProjectDialogDelete } from '../../dialogs'

export const ProjectActiveList = ({ actives, onUpdateProject }) => {
  const { t } = useTranslation()
  const ref = createRef()
  const dispatch = useDispatch()

  const isLoading = useContext(LoaderContext)

  const [searchValue, setSearchValue] = useState('')

  const onSearch = (txt) => {
    setSearchValue(txt)
    dispatch(searchProjects(txt))
  }

  const onCellEdit = (el) => {
    const projectUpdated = {
      ...el.row,
      active: el.value
    }
    Logger.trace(LoggerTypes.CONTROLLER, 'ProjectActiveList.onCellEdit()', { el, projectUpdated })
    if (el.field === 'active') {
      onUpdateProject(projectUpdated)
    }
  }

  const COLUMN_HEADER = [
    { field: 'id', hide: true },
    {
      field: 'name',
      type: 'string',
      headerName: t('projects.table.columns.name'),
      width: 250,
      flex: 1,
      renderCell: (e) => (
        <DataGridRowLink
          ref={ref}
          tooltip={e.row.description}
          href={getRoute(routePaths.SCENARIO_LIST, { pid: e.row.id })}
          text={e.formattedValue}
        />
      )
      // cellClassName: 'projectNameCell',
      // filterable: false,
      // editable: true,
      // resizable: true,
      // valueOptions: ['Credit card', 'Wire transfer', 'Cash'],
      // headerClassName: 'super-app-theme--header',
      // headerAlign: 'center',
      // cellClassName: 'super-app-theme--cell',
      // cellStyle: {
      //   whiteSpace: 'nowrap',
      //   width: '50%',
      //   backgroundColor: '#EEFF55'
      // },
    },
    /*
    {
      field: 'nb_simulations',
      type: 'integer',
      headerName: t('projects.table.columns.nb_simulations'),
      width: 140,
      editable: true,
    },
    */
    {
      field: 'number',
      type: 'string',
      headerName: t('projects.table.columns.number'),
      width: 110,
      editable: false
    },
    {
      field: 'scenario_count',
      type: 'integer',
      headerName: t('projects.table.columns.scenario_count'),
      width: 110,
      editable: false
    },
    {
      field: 'scenario_officials',
      type: 'integer',
      headerName: t('projects.table.columns.scenario_officials'),
      width: 110,
      editable: false
    },
    {
      field: 'user_name',
      type: 'string',
      headerName: t('projects.table.columns.author'),
      width: 110,
      editable: false
    },
    {
      field: 'creation_date',
      type: 'string',
      headerName: t('projects.table.columns.created_on'),
      width: 110,
      editable: false
    },
    {
      field: 'last_update_date',
      type: 'string',
      headerName: t('projects.table.columns.last_update'),
      width: 110,
      editable: false
    },
    {
      field: 'active',
      type: 'boolean',
      headerName: t('projects.table.columns.active'),
      width: 90,
      editable: true
    },
    {
      field: 'favorite',
      type: 'boolean',
      headerName: t('projects.table.columns.favorite'),
      width: 90,
      editable: false,

      disableClickEventBubbling: true,
      renderCell: (e) => <ProjectButtonFavorite project={e.row} />
    }
  ]

  // Logger.trace(LoggerTypes.CONTAINER, 'ProjectActiveList.render()', { actives, COLUMN_HEADER })

  return (
    <div className="projectList_projectActiveList">
      <PageTitle title={t('projects.table.types.active')} />
      <div className="projectList_projectActiveList_dataGrid">
        <DataGrid
          actionsButtons={
            ((
              <AccessControl
                userPermissions={[userRightTypes.PROJECT_ATTRIBUTES_EDIT]}
                renderNoAccess={() => <></>}
              ></AccessControl>
            ),
            [
              <ButtonIcon
                disabled={!checkPermissions([userRightTypes.PROJECT_EDIT])}
                key={'button-edit'}
                DialogClass={ProjectDialogUpdate}
                icon={<EditIcon />}
                tooltip={t('common.update')}
              />,
              <ButtonIcon
                disabled={!checkPermissions([userRightTypes.PROJECT_DELETE])}
                key={'button-delete'}
                DialogClass={ProjectDialogDelete}
                icon={<DeleteIcon />}
                tooltip={t('common.delete')}
              />
            ])
          }
          isLoading={isLoading}
          columns={COLUMN_HEADER}
          rows={actives}
          searchValue={searchValue}
          onSearch={onSearch}
          onCellEditCommit={onCellEdit}
        />
      </div>
    </div>
  )
}

ProjectActiveList.displayName = 'ProjectActiveList'

ProjectActiveList.propTypes = {
  actives: PropTypes.array.isRequired,
  onUpdateProject: PropTypes.func.isRequired
}

ProjectActiveList.defaultProps = {
  actives: [],
  onUpdateProject: () => {}
}
